import { render, staticRenderFns } from "./RequestResetPassword.vue?vue&type=template&id=6833b1a1&scoped=true"
import script from "./RequestResetPassword.vue?vue&type=script&lang=js"
export * from "./RequestResetPassword.vue?vue&type=script&lang=js"
import style0 from "./RequestResetPassword.vue?vue&type=style&index=0&id=6833b1a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833b1a1",
  null
  
)

export default component.exports